<template>
    <div>
        <Head :title="__(title)" />
        <div class="mb-6 flex justify-center items-center">
            <search-input v-model="searchFilter.search" class="w-full max-w-md mr-4 rtl:ml-4" :disableReset="true"></search-input>
            <div class="btn-indigo p-3 rounded-full cursor-pointer" @click="addNew">
                <icon class="w-5 h-5 fill-gray-100" name="plus"></icon>
            </div>
        </div>
        <div class="">
            <div class="mx-auto container py-6 px-2">
                <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    <div class="cursor-pointer transform hover:-translate-y-1 duration-200 transition-transform mb-6" v-for="event_type in event_types.data" :key="event_type.id" >
                        <div class="w-full h-64 flex flex-col event__types__grid bg-white shadow-md rounded rounded-lg border ckl" @click="eventTypeAction(event_type, $event)" :class="{'selected' : selectedEventTypes.includes(event_type.id), 'active': event_type.is_active}">
                            <div class="flex justify-between px-4 pb-3 top-border" :class="{'dd_open': !!event_type.is_open}"><!-- dd_open -->
                                <label class="select-none flex items-center" for="check_{{ event_type.id }}">
                                    <input id="check_{{ event_type.id }}" class="w-5 h-5" type="checkbox" @click="eventTypeCheckAction(event_type.id)" :checked="selectedEventTypes.includes(event_type.id)" />
                                </label>
                                <div class="flex setting__dd" @click="event_type.is_open = !event_type.is_open">
                                    <icon name="gear" class="w-4 h-4" />
                                    <i class="after__caret" />
                                </div>
                                <div class="flex flex-col et__setting__dd">
                                    <ul class="options">
                                        <li @click="goToLink(this.route('event_types.edit', event_type.id))"><icon name="edit" class="w-4 h-4" /> Edit</li>
                                        <li @click="cloneEventType(event_type.id)"><icon name="clone" class="w-4 h-4" /> Clone</li>
                                        <li @click="destroy(event_type.id)"><icon name="trash" class="w-4 h-4" /> Delete</li>
                                    </ul>
                                    <div class="on__off px-4 py-4">
                                        <label class="flex justify-between toggle_swtich items-center cursor-pointer">
                                            <div class="flex text-sm">
                                                On/Off
                                            </div>
                                            <div class="flex relative">
                                                <input type="checkbox" class="sr-only" v-model="event_type.is_active" @change="changeStatus($event, event_type.id)" />
                                                <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                                                <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="px-4 ckl">
                                <h4 class=" text-lg font-bold mb-3 ckl">{{ event_type.name }}</h4>
                                <p class="type___details ckl">{{ event_type.duration.replace('_', ' ') }}</p>
                                <p class=" type___details ckl">{{ event_type.details.length < 25 ? strippedContent(event_type.details) : strippedContent(event_type.details).substring(0, 25) + "..." }}</p>
                                <a v-if="event_type.is_active" :href="route('event_type.schedule', {username: $page.props.auth.user.username, event_type: event_type.link})" class="booking__link">View booking page</a>
                                <span v-else class="booking__link">View booking page</span>
                            </div>
                            <div class="px-4 copy__share">
                                <div class="flex items-center justify-between w-full">
                                    <div class="flex copy__link gap-2" @click="copyLink(event_type, $event)"><icon name="clone" class="w-3 h-3" /> <span class="c__text">{{ __('Copy link') }}</span> <span class="c__copied">{{ __('Copied!') }}</span> </div>
                                    <button v-if="!event_type.is_active" @click="activeInactiveAction(event_type, true)" class="turn_on__share">
                                        {{ __('Turn On') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h4 v-if="!event_types.data.length" class="flex justify-center items-center text-center font-bold">No event type found.</h4>
            </div>
        </div>
        <div class="flex justify-center">
            <pagination class="mt-6" :links="event_types.links" />
        </div>
    </div>
</template>


<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SearchInput from '@/Shared/SearchInput'
import TextareaInput from '@/Shared/TextareaInput'
import Pagination from '@/Shared/Pagination'
import Icon from '@/Shared/Icon'
import { Link, Head } from '@inertiajs/inertia-vue3'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
export default {
    layout: Layout,
    components: { Link, Head, SearchInput, Icon, TextareaInput, TextInput, Pagination },
    props: {
        filters: Object,
        title: String,
        event_types: Object,
    },
    data() {
        return {
            update_id: null,
            note_form: false,
            selectedEventTypes: [],
            searchFilter: {
                search: this.filters.search,
            },
            form: this.$inertia.form({
                id: null,
                name: null,
                color: null,
                details: null
            })
        }
    },
    watch: {
        searchFilter: {
            deep: true,
            handler: throttle(function() {
                this.$inertia.get(this.route('event_types.index'), pickBy(this.searchFilter), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        changeStatus(e, id){
            this.toggleStatus(id, e.currentTarget.checked)
        },
        toggleStatus(id, bol){
            this.axios.put(this.route('event_types.change_status', id), {is_active: bol}).then((response) => {
                console.log(response)
                console.log('done!')
            }).catch((error) => {
                console.log(error)
            })
        },
        goToLink(link){
            window.location.href = link;
        },
        cloneEventType(id){
            this.axios.post(this.route('event_types.clone'), {id: id}).then((response) => {
                window.location.href = this.route('event_types.index')
            }).catch((error) => {
                console.log(error)
            })
        },
        strippedContent(html) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        },
        eventTypeCheckAction(id){
            const index = this.selectedEventTypes.indexOf(id);
            if(index > -1){
                this.selectedEventTypes.splice(index, 1);
            }else{
                this.selectedEventTypes.push(id)
            }
        },
        settingMenuAction(){

        },
        eventTypeAction(event_type, event){
            if(event.target.classList.contains('ckl')){
                if(!this.selectedEventTypes.length){
                    window.location.href = this.route('event_types.edit', event_type.id);
                }else{
                    this.eventTypeCheckAction(event_type.id);
                }
            }
        },
        activeInactiveAction(event_type){
            this.toggleStatus(event_type.id, true)
            event_type.is_active = true
        },
        async copyLink(event_type, e){
            try {
                await navigator.clipboard.writeText(this.route('event_type.schedule', {username: this.$page.props.auth.user.username, event_type: event_type.link}));
                e.target.parentNode.classList.add('copied')
                setTimeout(function(){e.target.parentNode.classList.remove('copied')}, 2000)
            } catch($e) {
                console.log("Can't copy");
            }
        },
        addNew(){
            window.location.href = this.route('event_types.create')
        },
        destroy(id) {
            if (confirm('Are you sure you want to delete this event_type?')) {
                this.$inertia.delete(this.route('event_types.destroy', id),{
                    onSuccess: () => {
                        this.resetForm()
                    }
                })
            }
        },
        store(id) {
            this.form.post(this.route('event_types.save', id),{
                onSuccess: () => {
                    this.resetForm()
                    window.location.href = this.route('event_types.index')
                },
            })
        },
        resetForm(){
            this.note_form = false
            this.form.reset()
            this.update_id = null
        }
    },
    created() {
        console.log(this.event_types);
    }
}
</script>
